import { render } from "./JobCard.vue?vue&type=template&id=16b67cf8&scoped=true&ts=true"
import script from "./JobCard.vue?vue&type=script&lang=ts"
export * from "./JobCard.vue?vue&type=script&lang=ts"

import "./JobCard.vue?vue&type=style&index=0&id=16b67cf8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b67cf8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
